export const SpamReplyActors = {
    SPAM_REPLY_LIST:'SPAM_REPLY_LIST',
    SPAM_REPLY_TOGGLE:'SPAM_REPLY_TOGGLE'
}